import "../style.css";
import SEO from "../components/SEO";
import SiteFooter from "../components/SiteFooter";

function About() {
  return (
    <>





<SEO
  title="About Lappy Laptops"
  description="Lappy Used Laptops is a trusted laptop store in Namakkal providing affordable laptops and repair services."
  url="https://lappylaptops.com/about"
/>







    <div className="about-page">
      {/* HEADER */}
      <div className="about-header">
        <h2>About Lappy Used Laptops</h2>
        <p>Your trusted laptop shop in Namakkal</p>
      </div>

      {/* CONTENT */}
      <div className="about-content">
        <div className="about-box">
          <h3>Who We Are</h3>
          <p>
            Lappy Used Laptops is a local laptop sales & service center based in
            Namakkal. We specialize in new and refurbished laptops with quality
            assurance and affordable pricing.
          </p>
        </div>

        <div className="about-box">
          <h3>Our Mission</h3>
          <p>
            To provide reliable laptops, honest pricing, and long-term support
            to students, professionals, and businesses.
          </p>
        </div>

        <div className="about-box">
          <h3>Why Choose Us?</h3>
          <ul>
            <li>✔ Tested & verified laptops</li>
            <li>✔ Affordable prices</li>
            <li>✔ After-sales support</li>
            <li>✔ Trusted local service</li>
          </ul>
        </div>
      </div>
    </div>



      <section className="contact">
        <div>
          <h2 className="get">Get in Touch</h2>
          <p>📞 +91 8838619488</p>
          <p>✉️ <a href="mailto:lappylaptopsales@gmail.com" className="contact-email-link">lappylaptopsales@gmail.com</a></p>
          <p>📍 129 Salapalayam Road, Reddipatti, Namakkal, TamilNadu 637002</p>
          <p>📍 Lappy Laptops, 27, Devangar Street, Thathiengarpettai, Musiri-Tk, Trichy-Dt, Pincode: 621214. Landmark: Mini Radios.</p>
          <a
            href="https://wa.me/918838619488"
            target="_blank"
            rel="noreferrer"
            className="whatsapp"
          >
            WhatsApp Us
          </a>
        </div>

        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.730200578514!2d78.22037987429323!3d11.207586751094425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babc94be384bbb3%3A0xcdd0430efbea64f3!2sLappy%20Used%20Laptops%20Sales!5e0!3m2!1sen!2sin!4v1770279618891!5m2!1sen!2sin"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            title="Lappy Location"
          ></iframe>
        </div>
      </section>

      {/* FOOTER */}
      <SiteFooter />

</>



  );
}

export default About;


